import { createSelector } from "@reduxjs/toolkit";
import { State } from "../../store";
import { cartRoomI } from "./CartSlice.type";

export const selectCart = (state: State) => state.cart;

export const selectCartTotalPrice = createSelector(
  selectCart,
  (cart) => cart.totalPrice
);

export const selectCartItems = createSelector(
  selectCart,
  (cart) => cart.cartItems
);

export const selectCheckedOutItems = createSelector(
  selectCart,
  (cart) => cart.checkedOutItems
);

export const selectCartRoom = (hotelId: string, roomId: string) =>
  createSelector(selectCartItems, (cartItems) => {
    return cartItems
      .find((cartItem) => cartItem.id === hotelId)
      ?.rooms.find((room) => room.id === roomId);
  });

export const selectFormattedCartRooms = createSelector(
  selectCartItems,
  (cartItems) =>
    cartItems.map((cartItem) => ({
      ...cartItem,
      rooms: cartItem.rooms.reduce((acum, currentCartRoom) => {
        currentCartRoom.units.map((room) => {
          return room.map((roomUnit) => {
            return (acum = [
              ...acum,
              {
                addedExtras: roomUnit.addedExtras,
                adults: roomUnit.adults,
                bookingCondition: currentCartRoom.bookingCondition,
                checkin: roomUnit.checkin,
                checkout: roomUnit.checkout,
                childrenAgeList: roomUnit.childrenAgeList,
                extrasTotalPrice: roomUnit.extrasTotalPrice,
                id: roomUnit.id,
                name: currentCartRoom.name,
                occupancy: roomUnit.occupancy,
                paidNow: roomUnit.paidNow,
                price: roomUnit.price,
                priceNoOffer: roomUnit.priceNoOffer,
                rate: currentCartRoom.rateName,
                rateId: currentCartRoom.rateId,
                roomId: currentCartRoom.id,
                roomImage: currentCartRoom.image,
                amount: roomUnit.amount,
                freeCancellableTo: roomUnit.freeCancellableTo,
                refundable: roomUnit.refundable,
                isCouponApplied: roomUnit.isCouponApplied,
                couponQuantityDiscount: roomUnit.couponQuantityDiscount,
                couponPercentDiscount: roomUnit.couponPercentDiscount
              }
            ]);
          });
        });
        return acum;
      }, [] as cartRoomI[])
    }))
);

export const selectCartEnvironment = createSelector(
  selectCart,
  (cart) => cart.environmentId
);

export const selectFormattedCheckedOutItems = createSelector(
  selectCheckedOutItems,
  (checkedOutItems) =>
    checkedOutItems.map((checkedOutItem) => ({
      ...checkedOutItem,
      rooms: checkedOutItem.rooms.reduce((acum, currentCartRoom) => {
        currentCartRoom.units.map((room) => {
          return room.map((roomUnit) => {
            return (acum = [
              ...acum,
              {
                addedExtras: roomUnit.addedExtras,
                adults: roomUnit.adults,
                bookingCondition: currentCartRoom.bookingCondition,
                checkin: roomUnit.checkin,
                checkout: roomUnit.checkout,
                childrenAgeList: roomUnit.childrenAgeList,
                extrasTotalPrice: roomUnit.extrasTotalPrice,
                id: roomUnit.id,
                name: currentCartRoom.name,
                occupancy: roomUnit.occupancy,
                paidNow: roomUnit.paidNow,
                price: roomUnit.price,
                priceNoOffer: roomUnit.priceNoOffer,
                rate: currentCartRoom.rateName,
                rateId: currentCartRoom.rateId,
                roomId: currentCartRoom.id,
                roomImage: currentCartRoom.image,
                amount: roomUnit.amount,
                freeCancellableTo: roomUnit.freeCancellableTo,
                refundable: roomUnit.refundable,
                isCouponApplied: roomUnit.isCouponApplied
              }
            ]);
          });
        });
        return acum;
      }, [] as cartRoomI[])
    }))
);
